import ProjectTypes from '../../constants/ProjectTypes';
import withRequiredAuth from '../../HOC/withRequiredAuth';
import withRequiredProduct from '../../HOC/withRequiredProduct';
import ModeratorFinder from './ModeratorFinder';

export default withRequiredProduct(
  withRequiredAuth(ModeratorFinder),
  ProjectTypes.MODERATOR,
);
